import postDetailSlice from './slice';

const postDetailReducer = postDetailSlice.reducer;

export default postDetailReducer;
